import styled from "styled-components";
import { theme } from "../../styles/styles";

export const Hero = styled("section")`
  display: flex;
  align-items: center;
  gap: 2.5rem;
  margin: 0 0 2rem;
  padding: 3rem;
  border-radius: 20px;
  border: 1px solid ${theme.border};
  background: radial-gradient(
      ellipse at 0% 0%,
      rgba(255, 90, 60, 0.28),
      transparent 55%
    ),
    ${theme.surface};

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1.5rem;
    padding: 1.5rem;
  }
`;

export const HeroIcon = styled("img")`
  width: 168px;
  height: 168px;
  flex-shrink: 0;
  border-radius: 36px;
  box-shadow: 0 24px 60px rgba(255, 90, 60, 0.25), 0 0 0 1px ${theme.border};

  @media only screen and (max-width: 768px) {
    width: 96px;
    height: 96px;
    border-radius: 22px;
  }
`;

export const HeroTitle = styled("h1")`
  margin: 0 0 0.75rem;
  font-size: 52px;
  letter-spacing: 0.02em;

  span {
    display: block;
    font-size: 0.42em;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: ${theme.accent};
    margin-top: 0.4rem;
  }
`;

export const HeroTagline = styled("p")`
  max-width: 560px;
  margin: 0 0 1.5rem;
`;

export const HeroActions = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

export const StoreLink = styled("a")`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 1.1rem;
  border-radius: 10px;
  border: 1px solid ${theme.border};
  background: #e9ecf2;
  color: #0b0d12;
  font-family: "Motiva Sans Bold", sans-serif;
  font-size: 15px;
  transition: transform 0.15s ease-in-out, background 0.15s ease-in-out;

  img {
    width: 22px;
    height: 22px;
  }

  &:hover {
    color: #0b0d12;
    background: #fff;
    transform: translateY(-2px);
  }
`;

export const DocLinks = styled("div")`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const DocLink = styled("button")`
  cursor: pointer;
  padding: 0.45rem 1rem;
  border-radius: 999px;
  border: 1px solid ${theme.border};
  background: transparent;
  color: ${theme.text};
  font-size: 14px;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${theme.heading};
    border-color: ${theme.accent};
  }
`;
